// src/services/achievementService.js

// This file now contains ONLY data, no UI code.
export const allAchievements = [
  {
    id: 'streak-3',
    title: 'Am Ball geblieben',
    description: 'Lerne 3 Tage am Stück.',
    icon: 'Flame', // Icon is now a string
    check: (userProgress) => userProgress.studyStreak >= 3
  },
  {
    id: 'streak-7',
    title: 'Fleißige Biene',
    description: 'Lerne 7 Tage am Stück.',
    icon: 'Flame', // Icon is now a string
    check: (userProgress) => userProgress.studyStreak >= 7
  },
  {
    id: 'practice-10',
    title: 'Aufwärm-Champion',
    description: 'Schließe 10 Übungen ab.',
    icon: 'Zap', // Icon is now a string
    check: (userProgress) => userProgress.totalAnswered >= 10
  },
  {
    id: 'practice-50',
    title: 'Übungs-Meister',
    description: 'Schließe 50 Übungen ab.',
    icon: 'Zap', // Icon is now a string
    check: (userProgress) => userProgress.totalAnswered >= 50
  },
  {
    id: 'exam-1',
    title: 'Prüfungs-Pionier',
    description: 'Schließe deine erste Probeklausur ab.',
    icon: 'CheckCircle', // Icon is now a string
    check: (userProgress) => (userProgress.completedExams || 0) >= 1
  },
  {
    id: 'score-90',
    title: 'Spitzenleistung',
    description: 'Erreiche über 90% in einer Probeklausur.',
    icon: 'Award', // Icon is now a string
    check: (userProgress) => userProgress.bestScore >= 90
  },
];

export const getEarnedAchievements = (userProgress) => {
    if (!userProgress) return [];
    return allAchievements
        .filter(achievement => achievement.check(userProgress))
        .map(achievement => achievement.id);
};